module.exports = __webpack_public_path__ + "img/wx-share-1.0fbb238f.jpg";